// Line icons, drawn exactly as in the design.

export function MailboxIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="3" y="6" width="18" height="13" rx="2" />
      <path d="M3.6 7.4 12 14l8.4-6.6" />
    </svg>
  );
}

export function TrackIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M21.5 3.4 2.8 11.2l7 2.2 2.2 7z" />
      <path d="M21.5 3.4 9.8 13.4" />
    </svg>
  );
}

export function WriteIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M16.4 3.6l4 4-10 10-4.8.8.8-4.8 10-10z" />
      <path d="M4 21.4h7" />
    </svg>
  );
}

export function StampsIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="3.4" y="3.4" width="17.2" height="17.2" rx="2" stroke-dasharray="0.1 4.4" />
      <path d="M7.4 16l3.4-4.6 3 3 2.8-3.6" />
    </svg>
  );
}

export function ProfileIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="8.4" r="4.2" />
      <path d="M4.4 20.6c1.8-3.6 4.8-5 7.6-5s5.8 1.4 7.6 5" />
    </svg>
  );
}

export function BackArrow({ size }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M24 15H7" />
      <path d="M13.5 8.5 7 15l6.5 6.5" />
    </svg>
  );
}

export function UploadIcon() {
  return (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M23 32V11" />
      <path d="M14 20l9-9 9 9" />
      <path d="M8 34v3h30v-3" />
    </svg>
  );
}

export function CameraIcon({ size, stroke }: { size: number; stroke: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={stroke} stroke-linecap="round" stroke-linejoin="round" style={{ flex: 'none' }} aria-hidden="true">
      <path d="M3 8.5h4l1.6-2.4h6.8L17 8.5h4v11H3z" />
      <circle cx="12" cy="13.6" r="3.4" />
    </svg>
  );
}

export function CrossIcon() {
  return (
    <svg width="9" height="9" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
      <path d="M2.5 2.5l7 7M9.5 2.5l-7 7" />
    </svg>
  );
}

export function EnvelopeGlyph({ ink }: { ink: string }) {
  return (
    <g fill={ink}>
      <path d="M2 3h26a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      <path d="M1.6 4.6 15 13.4 28.4 4.6" fill="none" stroke="#F7F0E1" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
    </g>
  );
}

export function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
    </svg>
  );
}
